(function ($, bootstrap, scrollToFixed) {

  $(document).ready(function () {

    var headerHeight = 100 + parseInt($('header').outerHeight(true));
    if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {

      $('.header-menu-fixed').scrollToFixed({
        marginTop: $('#wpadminbar').length > 0 ? $('#wpadminbar').outerHeight(true) : 0,
      });
    }


    $('.navbar-right__container').on('click', function(){
      $(this).toggleClass('active');
      $('.desktop-menu-right').toggleClass('desktop-menu-right__show');
    });

    $('.desktop-menu-right__close').on('click', function(){
      $('.navbar-right__container').removeClass('active');
      $('.desktop-menu-right').removeClass('desktop-menu-right__show');
    });

    $('.menu-item-has-children > a').on('click', function(){
      var ele = $(this).parent();
      ele.toggleClass('submenu-open');
    });



    $(window).scroll(function (ele) {
      if ($(document).scrollTop() < headerHeight) {
        postfixed('.header-menu-fixed__container');
      } else {
        prefixed('.header-menu-fixed__container');
      }


      if ($('.nav-project-division').length > 0) {
        var anchor = effectAnchor(),
          i = 1;
        while (i < anchor.length - 1) {
          if ($(window).scrollTop() >= (parseFloat(anchor[i][1]) - 50) && $(window).scrollTop() <= (parseFloat(anchor[i + 1][1]) - 50)) {
            $('.' + anchor[i][0]).addClass('text-hover');
          } else {
            $('.' + anchor[i][0]).removeClass('text-hover');
          }
          i++;
        }
      }

    });

    svg_transform('.header-menu__logo img');
    svg_transform('a.mobile-image img');
    svg_transform('.header-menu-fixed__logo img');
    svg_transform('footer img.footer-logo');
    svg_transform('header .desktop-menu img');
  });

  function prefixed(ele) {
    $(ele).show();
    $('.header-menu-fixed__container').addClass('menu-show');
  }

  function postfixed(ele) {
    $('.header-menu-fixed__container').removeClass('menu-show');
  }

  function effectAnchor() {

    var newArray = [];
    newArray.push(['zero', 0]);
    $('.anchor-scroll').each(function () {
      newArray.push([$(this).attr('id'), $(this).offset().top]);
    });
    newArray.push(['max', $(document).height()]);
    return newArray;
  }


  function svg_transform(elem) {

    var color = color || false;

    $(elem).each(function () {
      var img = $(this);
      var image_uri = img.attr('src');
      $.get(image_uri, function (data) {
        var svg = $(data).find('svg');
        svg.removeAttr('xmlns:a');
        svg.addClass(img.attr('class'));
        svg.addClass('img-fluid');
        svg.attr('width', img.css('width'));
        svg.attr('height', img.css('height'));
        svg.addClass('img-fluid');
        var listg = svg.find('g');
        for (var i = 0; i < listg.length; i++) {
          var obi = listg[i];
          if (color) {
            if ($(obi).attr('fill') !== undefined && $(obi).attr('fill') !== 'none') {
              $(obi).attr('fill', color);
            }


            if ($(obi).attr('stroke') !== undefined && $(obi).attr('stroke') !== 'none') {
              $(obi).css('stroke', color);
            }
          } else {
            if ($(obi).attr('fill') !== undefined && $(obi).attr('fill') !== 'none') {
              $(obi).attr('fill', $(obi).attr('fill'));
            }


            if ($(obi).attr('stroke') !== undefined && $(obi).attr('stroke') !== 'none') {
              $(obi).css('stroke', $(obi).attr('stroke'));
            }
          }

        }
        var listp = svg.find('path');

        for (var j = 0; j < listp.length; j++) {
          var obj = listp[j];
          if ($(obj).attr('fill') !== undefined && $(obj).attr('fill') !== 'none') {
            if (color) {
              $(obj).attr('fill', color);
            } else {
              $(obj).attr('fill', $(obj).attr('fill'));
            }
          }
        }
        img.replaceWith(svg);

      }, 'xml');
    })
  }


}(jQuery, Bootstrap, Scrolltofixed));